import React, { Dispatch } from 'react';
import TitleView from './TitleView';
import TimeView from 'pages/MainCalendarPage/AppointmentView/TimeView';
import AttendeesView from './AttendeesView';
import LocationView from 'pages/MainCalendarPage/AppointmentView/LocationView';
import AuditView from 'pages/MainCalendarPage/AppointmentView/AuditView';
import { AppointmentViewWrapper } from './style';
import { IEvent, SidebarState } from 'model/v2';

interface Props {
  observationEvent: IEvent;
  leadEvent: any;
  openSidebar: (sidebarState: SidebarState) => void;
  setIsAddObservationMode: Dispatch<React.SetStateAction<boolean>>;
}
const ObserverView: React.FC<Props> = ({
  observationEvent,
  leadEvent,
  openSidebar,
  setIsAddObservationMode
}: Props) => {
  return (
    <AppointmentViewWrapper>
      <>
        {observationEvent.leadEvent && leadEvent && (
          <div className="scrollable">
            <TitleView event={observationEvent} />
            <TimeView event={observationEvent} isObservation={true} />
            <AttendeesView
              LeadProvider={observationEvent.leadEvent.provider}
              leadEvent={leadEvent.event}
              provider={observationEvent.provider}
              openSidebar={openSidebar}
              setIsAddObservationMode={setIsAddObservationMode}
            />
            {observationEvent.appointmentType?.eventType?.name === 'ABA' ? (
              <>
                <LocationView event={observationEvent} isObservation={true} />
              </>
            ) : (
              <>
                <LocationView
                  event={observationEvent.leadEvent}
                  isObservation={true}
                />
              </>
            )}
            <AuditView event={observationEvent} isObservation={true} />
          </div>
        )}
      </>
    </AppointmentViewWrapper>
  );
};
export default React.memo(ObserverView);
